import React, { useState, useEffect } from 'react'
import { GetSuppliersLogo, GetHomeSliderItems } from '../../../Services/CompanyInfoService'
import { useConfig } from '../../../Providers/ConfigProvider'

const useGetLogosAndSliderItems = () => {

    const [SuppliersLogo, setSuppliersLogo] = useState([])
    const [HomeSliderItems, setHomeSliderItems] = useState([])

    const { api } = useConfig()

    useEffect(() => {
        GetSuppliersLogo(api)
            .then(res => setSuppliersLogo(res.data))
    }, [])

    useEffect(() => {
        GetHomeSliderItems(api)
            .then(res => setHomeSliderItems(res.data))
    }, [])

    return { SuppliersLogo, HomeSliderItems }
}

export default useGetLogosAndSliderItems